// Module
var code = "<div id=container style=margin:15px;width:1000px;height:8px;position:relative></div>";
// Exports
module.exports = code;